export default async function getAPIKeys() {
  const responce = await fetch(
    "https://ai-chat-bot-docker.onrender.com/getapikeys",
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  const json = await responce.json();

  return { sbUrl: json.sbUrl, sbApiKey: json.sbApiKey };
}
